module.exports = __webpack_public_path__ + "img/yellow-bg.6de2d08a.png";